import React from 'react';
import he from 'he';
import Link from 'app/components/misc/Link';
import mixpanel, { trackedEvents } from 'app/utils/mixpanel';
import clsx from 'clsx';
import Byline from '../Byline';

const truncateTitle = title => {
  const maxCharacters = 70;
  return title.length > maxCharacters
    ? `${title.substr(0, maxCharacters - 1)}&hellip;`
    : title;
};

const ArticleLink = ({ link, slug, children }) => {
  return (
    <Link {...link}>
      <a
        className="font-bold pt-1 pb-2 min-h-[54px] hover:text-blue-500"
        onClick={() => {
          mixpanel.track(trackedEvents.MobileArticleCarousel, {
            params: 'related_articles',
            slug,
          });
        }}
      >
        {children}
      </a>
    </Link>
  );
};

const ArticleCard = ({
  imageUrl,
  title,
  author,
  publishDate,
  categories,
  duration,
  link,
  slug,
  theme = 'default',
}) => {
  const mainCategory = categories[0];
  const displayTitle = he.decode(truncateTitle(title));
  return (
    <div
      className={clsx(
        'rounded bg-white flex flex-col items-center shadow-sm w-[288px]',
        theme === 'large' && 'lg:w-[370px]',
        theme === 'default' && 'lg:w-[322px]',
        theme === 'small' && 'lg:w-[210px]',
      )}
    >
      <div className="p-3">
        <a link={link} slug={slug}>
          <img
            className="rounded h-[182px] w-[346px] hover:opacity-90"
            alt="article"
            loading="lazy"
            src={imageUrl}
          />
        </a>
      </div>
      <div className="p-3 w-full flex flex-col h-fit">
        <Link as={mainCategory?.link?.as} href={mainCategory?.link?.href}>
          <a className="uppercase text-xs font-bold text-blue-500">
            {mainCategory && he.decode(mainCategory?.name)}
          </a>
        </Link>
        <ArticleLink link={link} slug={slug}>
          {displayTitle}
        </ArticleLink>
        <Byline author={author} publishDate={publishDate} duration={duration} />
      </div>
    </div>
  );
};

export default ArticleCard;
